const cookies = () => {
  if (document.body.dataset.environment != 'production') return;

  let cookieBotDialog = document.querySelector('#CybotCookiebotDialog');

  if (typeof Cookiebot === 'undefined') {
    console.log('Cookiebot not loaded yet');
    return;
  }

  if (
    Cookiebot &&
    Cookiebot.show &&
    !Cookiebot.hasResponse &&
    (!cookieBotDialog || cookieBotDialog.style.display == 'none')
  ) {
    Cookiebot.show();
  }

  document.querySelectorAll('a.open-cookie-consent').forEach((el) => {
    if (!el.dataset.clickBinded) {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        if (Cookiebot && Cookiebot.show) Cookiebot.show();
      });
      el.dataset.clickBinded = true;
    }
  });

  try {
    if (Cookiebot && Cookiebot.consent && Cookiebot.consent.preferences) {
      document.querySelectorAll('div[data-youtube-iframe').forEach((el) => {
        if (!el.dataset.youtubeIframeBinded) {
          el.innerHTML = `<iframe class='video' src='${el.dataset.src}' frameborder='0' allow='encrypted-media' allowfullscreen></iframe>`;
          el.dataset.youtubeIframeBinded = true;
        }
      });

      document.querySelectorAll('div[data-google-map-iframe').forEach((el) => {
        if (!el.dataset.youtubeIframeBinded) {
          el.innerHTML = `<iframe src='${el.dataset.src}' frameborder='0' tabindex='0' ariaHidden='false' allowfullscreen></iframe>`;
          el.dataset.youtubeIframeBinded = true;
          el.classList.remove('d-none');
        }
      });
    }
  } catch (err) {
    console.log(err);
  }
};

window.addEventListener(
  'CookiebotOnAccept',
  function (e) {
    if (document.body.dataset.environment != 'production') return;
    
    if (Cookiebot.consent.statistics) {
      var _paq = (window._paq = window._paq || []);
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      // _paq.push(['trackPageView']); // NOTE: moved to script
      _paq.push(['enableLinkTracking']);
      (function () {
        var u = '//matomo.fra3.timi.cz/';
        _paq.push(['setTrackerUrl', u + 'matomo.php']);
        _paq.push(['setSiteId', '1']);
        var d = document,
          g = d.createElement('script'),
          s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = u + 'matomo.js';
        s.parentNode.insertBefore(g, s);
      })(); //Execute code that sets marketing cookies

      // Matomo Tag Manager
      if (document.querySelector('meta[name="matomo-src"]')) {
        var matomoSrc = document.querySelector(
          'meta[name="matomo-src"]'
        ).content;
        var _mtm = (window._mtm = window._mtm || []);
        _mtm.push({
          'mtm.startTime': new Date().getTime(),
          event: 'mtm.Start',
        });
        var d = document,
          g = d.createElement('script'),
          s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = matomoSrc;
        s.parentNode.insertBefore(g, s);
      }
    }

    if (Cookiebot.consent.marketing) {
      // Google
      // var googleTagManagerScript = document.createElement('script');
      // googleTagManagerScript.src = '//www.googletagmanager.com/gtag/js?id=AW-11033404865';
      // googleTagManagerScript.onload = () => {
      //   window.dataLayer = window.dataLayer || [];
      //   function gtag(){dataLayer.push(arguments);}
      //   gtag('js', new Date());
      //   gtag('consent', 'default', {
      //     'ad_storage': 'granted',
      //     'ad_user_data': 'granted',
      //     'ad_personalization': 'granted',
      //     'analytics_storage': 'granted',
      //     'wait_for_update': 500
      //   });
      //   gtag('config', 'AW-11033404865');
      //   window.gtag = gtag
      // }
      // document.head.appendChild(googleTagManagerScript);

      // Gtag
      if (typeof gtag !== 'undefined') {
        gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted'
        });
      }

      // Facebook
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
      );
      fbq('init', '1293084097897908');
    }

    // TikTok
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      (ttq.methods = [
        'page',
        'track',
        'identify',
        'instances',
        'debug',
        'on',
        'off',
        'once',
        'ready',
        'alias',
        'group',
        'enableCookie',
        'disableCookie',
        'holdConsent',
        'revokeConsent',
        'grantConsent',
      ]),
        (ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        });
      for (var i = 0; i < ttq.methods.length; i++)
        ttq.setAndDefer(ttq, ttq.methods[i]);
      (ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
          ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      }),
        (ttq.load = function (e, n) {
          var r = 'https://analytics.tiktok.com/i18n/pixel/events.js',
            o = n && n.partner;
          (ttq._i = ttq._i || {}),
            (ttq._i[e] = []),
            (ttq._i[e]._u = r),
            (ttq._t = ttq._t || {}),
            (ttq._t[e] = +new Date()),
            (ttq._o = ttq._o || {}),
            (ttq._o[e] = n || {});
          n = document.createElement('script');
          (n.type = 'text/javascript'),
            (n.async = !0),
            (n.src = r + '?sdkid=' + e + '&lib=' + t);
          e = document.getElementsByTagName('script')[0];
          e.parentNode.insertBefore(n, e);
        });

      ttq.load('CRHDB4BC77UALODS35M0');
      ttq.page();
    })(window, document, 'ttq');
  },
  false
);

export default cookies;